// shamelessly stolen from https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
const EMAIL_REGEX =
  /^[\w!#$%&'*+./=?^`{|}~-]+@[\dA-Za-z](?:[\dA-Za-z-]{0,61}[\dA-Za-z])?(?:\.[\dA-Za-z](?:[\dA-Za-z-]{0,61}[\dA-Za-z])?)*$/;

const NO_URLS_REGEX = /^((?!(www\.|\.com|(http:\/\/)|(https:\/\/))).)*$/i;
const BIRTHDATE_REGEX = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
const SSN_REGEX = /^(\d{9}|(\d{3}-\d{2}-\d{4}))$/;
const SIN_REGEX = /^(\d{9})|((?:\d{3}\s){2}\d{3})$/;

const PHONE_REGEX_BY_COUNTRY = {
  // TODO(ES): Correct this for Spain
  ES: /^\d{9}$/,
  FR: /^0[1-9](?:[\s.-]*\d{2}){4}|0[\s.-]8\d{2}(?:[\s.-]\d{3}){2}$/,
  IE: /^\s*\(?\s*\d{1,4}\s*\)?\s*[\d\s]{5,10}\s*$/,
  US: /^\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})$/,
  JP: /^0\d{9,10}|^0\d{1,2}-\d{4}-\d{4}|^0\d{2}-\d{3}-\d{4}|^0\d{3}-\d{2}-\d{4}|^0\d{4}-\d-\d{4}|^0\d{3}-\d{3}-\d{3}$/,
};

const PO_BOX_REGEX_BY_COUNTRY = {
  DEFAULT:
    /((number|num|#)?\s?\d*)?\s?(\b(post|p)[\s.]*(office|o)[\s.]*(bin|box|\d+)[\s.]?)\s?(((num|number|#)?\s?\d*)?)/i,
  ES: /^\s*((aparta(do|t)|b[uú]stia)\s?(de\s?)?(postal|corre[ou]s?))\s?.*/i,
  FR: /^\s*(((b\.?\s?p\.?))|(bo[iî]te\s?postale?))\s?.*/i,
};

const POSTAL_CODE_REGEX_BY_COUNTRY = {
  ES: /^(?:[0-24]\d|3[^58]|50)\d{3}$/,
  FR: /^([0-8]\d|9[0-6])\d{3}$/,
  IE: /^(?:^[ac-fhknprtv-y]\d{2}|d6w)[ -]?[\dac-fhknprtv-y]{4}$/i,
  US: /^\d{5}(-\d{4})?$/,
  // https://stackoverflow.com/questions/164979/regex-for-matching-uk-postcodes/7259020#7259020
  GB: /^(gir ?0aa|([a-fhk-pr-uwyz]|g(?![xy])|i(?!m)|j(?!e))(\d{1,2}|([a-hk-y]\d([\dabehmnprv-y])?)|\d[a-hjkps-uw]) ?\d[abd-hjlnp-uw-z]{2})$/i,
  // Source: https://en.wikipedia.org/wiki/Postcodes_in_Australia
  AU: /^\d{4}$/,
  // https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9781449327453/ch04s15.html
  // NOTE: replaced the "Black Circle" unicode character with a literal space...
  CA: /^(?!.*[dfioqu])[a-vxy]\d[a-z] ?\d[a-z]\d$/i,
  // Source: https://en.wikipedia.org/wiki/Postal_codes_in_Japan
  JP: /^\d{3}-?\d{4}$/,
};

const TAX_NUMBER_REGEX_BY_COUNTRY = {
  ES: /^[\da-z]\d{7}[\da-z]$/i,
  IE: /^\d{7}([a-z]{1,2})?$|^\d[a-z]\d{5}[a-z]$/i,
  FR: /^[\da-hj-np-z]{2}\d{9}$/i,
};

const EQUIFAX_PATTERNS = {
  name: /^[A-Za-z]+([\s'.A-Za-z-]*)$/,
  street: /^[\d\s#'./A-Z\\a-z-]*$/,
  city: /^[\s.A-Za-z-]*$/,
};

const CREDITSAFE_PATTERNS = {
  name: /^[\d\sA-Za-z-]*$/,
  street: /^[\d\s#A-Za-z-]*$/,
  city_state: /^[\d\sA-Za-z-]*$/,
};

const EXPERIAN_PATTERNS = {
  name: /^[A-Za-z]+([\s'.A-Za-z-]*)$/,
  street: /^[\d\s#'./A-Z\\a-z-]*$/,
  city: /^[\s.A-Za-z-]*$/,
};

export {
  EMAIL_REGEX,
  PHONE_REGEX_BY_COUNTRY,
  BIRTHDATE_REGEX,
  SSN_REGEX,
  SIN_REGEX,
  NO_URLS_REGEX,
  EQUIFAX_PATTERNS,
  EXPERIAN_PATTERNS,
  CREDITSAFE_PATTERNS,
  PO_BOX_REGEX_BY_COUNTRY,
  POSTAL_CODE_REGEX_BY_COUNTRY,
  TAX_NUMBER_REGEX_BY_COUNTRY,
};
